<template>
  <div class="bb-cache-register">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <div class="bb-popup-export-excel">
      <i class="icon-menu bb-popup-export-excel__icon" @click.stop="popupExport = true"/>
      <transition name="bounce">
        <div class="bb-popup-export-excel-popup"
             @click.stop="openExport()"
             v-if="popupExport"
             v-click-outside="hidePopupExport">
          <span class="bb-popup-export-excel-popup__text">Export to Excel</span>
        </div>
      </transition>
    </div>
    <Table :options="options"
           :totalPages="fullCache.totalPages"
           @openProforma="openTaxCreditNote"
           :multiple="true"
           :min-width="1200"/>
    <button class="bb-button-dashed" @click.stop="newExpenses()">
      <i class="icon-cross"></i>
      Add new
    </button>
    <Pagination :data="fullCache" :getQuery="getCache" :limit="defLimit" class="bb-pagination"/>
    <transition name="fade" mode="out-in">
      <ExportExcel :columns="columnsData"
                   v-if="openSettingExport"
                   :data="dataForExport"
                   file-name="cache-register"
                   :generateExcel="generateExcel"
                   @close="hideSettingExport"/>
    </transition>
    <transition name="fade" mode="out-in">
      <ModalWindow v-if="creditNoteProforma" @close="closeCreditNoteProforma">
        <template v-slot:buttons>
          <div class="bb-cache-register__send">
            <ButtonsEdit :left-if="false"
                         @delete="proformaEvents.cancel()"
                         no-pop-up="false"
                         btn-right-text="CANCEL"
                         styles="accent"/>
          </div>
        </template>
        <CreditNoteProforma ref="proformaCreditNote"
                            :editableSoaCreditNote="editableSoaCreditNote"
                            @close="closeCreditNoteProforma"
                            :view-mode="true"/>
      </ModalWindow>
    </transition>
  </div>
</template>

<script>
import {FOUNDER} from '@/constants/roles'
import {cacheTable, cacheTableColumns} from '@/constants/TablesOptions/cacheRegisrerTable'
import CacheApi from '@/api/CacheRegister/api'
import ExpensesCategoryApi from '@/api/ExpenseCategories/api'
import Table from '@/components/Main/Table/Table'
import Pagination from '@/components/Main/Pagination/Pagination'
import TotalCard from '@/components/Finance/InvoiceTable/TotalCard/TotalCard'
import {get, forEach, findIndex, cloneDeep, uniq, find, filter, sortBy} from 'lodash'
import sortByDate from '@/mixin/sortByDate'
import moment from 'moment'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import UploadFileApi from '@/api/UploadFile/api'
import ExportExcel from '@/components/Main/ExportExcel/ExportExcel'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'
import ModalWindow from '@/components/Main/ModalWindow/ModalWindow'
import ButtonsEdit from '@/components/Main/ButtonsEdit/ButtonsEdit'
import CreditNoteProforma from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/CreditNoteProforma'
import SoaCreditNote from '@/api/SoaCreditNote/api'

export default {
  name: 'CacheExpenses',
  mixins: [sortByDate],
  props: ['total'],
  components: {
    Table,
    TotalCard,
    Pagination,
    LoaderFly,
    CreditNoteProforma,
    ButtonsEdit,
    ModalWindow,
    ExportExcel,
    VuePerfectScrollbar
  },
  data () {
    return {
      fullFilter: false,
      filterByKey: [],
      newFiles: [],
      uploadsFiles: [],
      loaderRun: false,
      filterByDate: this.defaultRangeDate,
      currentPage: 1,
      fullCache: '',
      popupExport: false,
      openSettingExport: false,
      dataForExport: {},
      defLimit: 50,
      creditNoteProforma: false,
      proformaEvents: {
        cancel: false
      },
      editableSoaCreditNote: '',
      options: cacheTable,
      crypt: true,
      files: {}
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    defaultRangeDate () {
      const start = moment().subtract(10, 'years').format('YYYY-MM-DD')
      const end = moment().format('YYYY-MM-DD')
      return `dateOfPayment=${start};;${end}`
    },
    cacheColumnsData: {
      get: function () {
        return this.$store.getters.cacheColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setCacheColumnsData', data)
      }
    },
    cacheRowsData: {
      get: function () {
        return this.$store.getters.cacheRowsData
      },
      set: function (data) {
        this.$store.dispatch('setCacheRowsData', data)
      }
    },
    columnsData () {
      return this.cacheColumnsData.filter(item => item.title)
    }
  },
  methods: {
    async generateExcel (data) {
      const resp = await CacheApi.generateExcel(data)
      return resp
    },
    hideSettingExport () {
      this.hidePopupExport()
      this.openSettingExport = false
    },
    openExport () {
      this.openSettingExport = true
      this.dataForExport = {
        query: this.fullFilter
      }
    },
    hidePopupExport () {
      this.popupExport = false
    },
    addActions () {
      forEach(this.cacheColumnsData, item => {
        if (item.actions) {
          item.actions.delete = this.deleteCache
          item.actions.edit = this.editCache
          item.actions.getFile = this.openFile
          item.actions.uploadFile = this.uploadAllFiles
          item.actions.deleteFile = this.deleteFile
          item.actions.filter = this.setFilter
        }
      })
    },
    setFilter (data, item, property) {
      if (data) {
        const res = {
          query: `&${property}[]=${item.id}`,
          id: item.id
        }
        this.filterByKey.push(res)
      } else {
        const index = findIndex(this.filterByKey, {id: item.id})
        this.filterByKey.splice(index, 1)
      }
      this.getCache({limit: this.defLimit})
    },
    uploadAllFiles (files, row, rows, copyRow) {
      this.newFiles = []
      forEach(files, file => {
        this.uploadFile(this.setFileData(file), row, rows, copyRow)
      })
    },
    uploadFile (fileData, row, rows, copyRow) {
      const index = findIndex(rows, {id: row.id})
      UploadFileApi.createFile(fileData, this.crypt)
        .then((resp) => {
          this.newFiles.push(resp.data)
          this.uploadsFiles.push(resp.data)
          row = cloneDeep(copyRow)
          const oldFile = row.uploadFile || []
          row.uploadFile = uniq(oldFile.concat(this.newFiles))
          if (index !== -1) {
            rows.splice(index, 1, row)
          } else if (row.newMode) {
            rows.splice(0, 1, row)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file)
    },
    getFile (file) {
      this.loaderRun = true
      UploadFileApi.getFile(file.id, this.crypt)
        .then((resp) => {
          this.openForm = true
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    deleteFile (id, row, rows, copyRow) {
      const index = findIndex(rows, {id: row.id})
      UploadFileApi.deleteFile(id, this.crypt)
        .then(() => {
          row = cloneDeep(copyRow)
          const oldFile = row.uploadFile || []
          const indexFile = findIndex(oldFile, {id: id})
          if (indexFile !== -1) oldFile.splice(indexFile, 1)
          if (index !== -1) {
            rows.splice(index, 1, row)
          } else if (row.newMode) {
            rows.splice(0, 1, row)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setFileData (file) {
      const fileData = new FormData()
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', file.name || '')
      fileData.set('file', file)
      return fileData
    },
    isFounder () {
      const role = get(this.userInfo, 'role', '')
      return role === FOUNDER.id
    },
    newExpenses () {
      const cache = {
        approved: this.isFounder(),
        company: '',
        dateOfPayment: new Date(),
        amountAED: 0,
        creditAED: 0,
        newMode: true,
        create: this.createCache
      }
      const newHave = find(this.cacheRowsData, {newMode: true})
      if (newHave) {
        return
      }
      this.cacheRowsData.unshift(cache)
    },
    closeCreditNoteProforma () {
      this.editableSoaCreditNote = ''
      this.creditNoteProforma = false
    },
    openTaxCreditNote (creditNote) {
      const creditNoteId = get(creditNote, 'cnId', '')
      if (!creditNoteId) return
      this.loaderRun = true
      SoaCreditNote.getSoaCreditNotesById(creditNoteId)
        .then((resp) => {
          this.loaderRun = false
          this.editableSoaCreditNote = resp.data
          this.creditNoteProforma = true
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getExpensesCategories () {
      ExpensesCategoryApi.getExpenseCategories()
        .then((resp) => {
          this.cacheColumnsData.forEach(item => {
            if (item.listName === 'expensesCategory') {
              const expenses = filter(resp.data.expensesCategories, category => {
                return category.type === item.categoryType && !category.isPayroll
              }) || []
              item.list = sortBy(expenses, ['name'])
            }
          })
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getCacheTotal ({query}) {
      this.getCacheTotalBalance()
      CacheApi.getCacheTotal({query})
        .then((resp) => {
          const totalAmount = resp.data.totalAmount || 0
          this.$emit('setTotal', totalAmount)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getCacheTotalBalance () {
      CacheApi.getCacheTotal({})
        .then((resp) => {
          const balance = resp.data.totalBalanceAed || 0
          this.$emit('setTotalBalance', balance)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    createFilterQuery (filter) {
      let fullQuery = ''
      if (this.filterByKey.length === 0) return filter
      this.filterByKey.forEach(item => {
        fullQuery += item.query
      })
      return filter + fullQuery
    },
    getCache ({limit = this.defLimit, page, filter}) {
      this.currentPage = page || this.currentPage
      this.loaderRun = true
      if (filter) {
        this.filterByDate = `dateOfPayment=${filter}`
      }
      if (!filter && !this.filterByDate) {
        this.filterByDate = this.defaultRangeDate
      }
      this.fullFilter = this.createFilterQuery(this.filterByDate)
      this.getCacheTotal({query: this.fullFilter})
      CacheApi.getCache({limit, page: this.currentPage, filter: this.fullFilter})
        .then((resp) => {
          this.fullCache = resp.data
          this.cacheRowsData = resp.data.cacheregisters.map(item => {
            if (item.soaId) {
              item.paymentDescription = item.soaDescription
              item.secondCategory = {name: item.soaClient}
              item.static = false
              item.onlyApprove = true
            }
            const approved = !this.isFounder() && item.approved
            if (item.salary || approved) {
              item.static = true
            }
            if (item.salary && !approved) {
              item.static = false
              item.onlyApprove = true
            }
            if (!item.approved) {
              item.$highlight = true
            }
            if (item.soaRefund) {
              item.uploadFile = item.uploadFile.concat(item.soaRefund.uploadFile)
              item.secondCategory = {name: item.soaClient}
            }
            return item
          })
          this.loaderRun = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    createCache (item) {
      delete item.$highlight
      item.uploadFile = this.uploadsFiles.map(item => item.id)
      CacheApi.createCache(item)
        .then((resp) => {
          resp.data.uploadFile = this.uploadsFiles
          resp.data.category = item.origincategory
          resp.data.secondCategory = item.originsecondCategory
          resp.data.typeOfPayment = item.origintypeOfPayment
          this.cacheRowsData.unshift(resp.data)
          this.getCacheTotal({query: this.filterByDate})
          this.uploadsFiles = []
          this.getCache({limit: this.defLimit})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    editCache (item) {
      if (typeof item.category === 'object') item.category = get(item, 'category.id', '')
      if (typeof item.secondCategory === 'object') {
        const id = get(item, 'secondCategory.id', '')
        id ? item.secondCategory = id : delete item.secondCategory
      }
      delete item.$highlight
      const oldFiles = filter(item.uploadFile, item => item.path || item.id).map(item => item.id)
      const newFiles = this.uploadsFiles.map(item => item.id)
      item.uploadFile = uniq(newFiles.concat(oldFiles))
      const index = (findIndex(this.cacheRowsData, {id: item.id}))
      CacheApi.editCache(item)
        .then((resp) => {
          resp.data.category = item.origincategory
          resp.data.secondCategory = item.originsecondCategory
          resp.data.typeOfPayment = item.origintypeOfPayment
          this.cacheRowsData.splice(index, 1, resp.data)
          this.getCacheTotal({query: this.filterByDate})
          this.uploadsFiles = []
          this.getCache({limit: this.defLimit})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteCache (id) {
      const trueIndex = (findIndex(this.cacheRowsData, {id: id}))
      CacheApi.deleteCache(id)
        .then(() => {
          this.cacheRowsData.splice(trueIndex, 1)
          this.getCacheTotal({query: this.filterByDate})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setColumnsData () {
      const role = get(this.userInfo, 'role', '')
      this.cacheColumnsData = cacheTableColumns.filter(col => {
        const access = col.access || []
        const checkAccess = access.includes(role)
        return access.length === 0 || checkAccess
      })
      this.addActions()
    }
  },
  updated () {
    if (this.$refs.proformaCreditNote) {
      this.proformaEvents.cancel = this.$refs.proformaCreditNote.cancelProforma
    }
  },
  beforeMount () {
    this.$emit('setQuery', this.getCache)
    this.getExpensesCategories()
    this.setColumnsData()
  }
}

</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-cache-register {
  @include global-font;
  position: relative;

  &-balance {
    &__document {
      width: 70vw;
      height: 74vh;
    }
  }

  &__send {
    position: relative;
    padding-bottom: 0;
    padding-top: 30px;
    margin-right: 8px;
    display: flex;
    justify-content: flex-end;
    box-shadow: 0 -10px 35px -15px rgba($color-silver, 0.4);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Finance/Expenses/CacheRegister/CacheRegister.vue